/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"

import "./src/styles/custom.css"

import * as React from "react"
import CookieBanner from "./src/zerer-cookie-consent/CookieBanner"

const CONSENT_KEY = "zerer_cookie_consent"
const GTAG_ID = "G-7H75XWB76Q"

function grantAnalyticsConsent() {
  if (typeof window === "undefined") return
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: "granted" })
    window.gtag("event", "page_view", { page_path: window.location.pathname })
  }
}

export const onClientEntry = () => {
  window.__activateAnalytics = grantAnalyticsConsent

  try {
    const raw = localStorage.getItem(CONSENT_KEY)
    if (raw) {
      const consent = JSON.parse(raw)
      if (consent.analytics === true) {
        window.addEventListener("load", grantAnalyticsConsent, { once: true })
      }
    }
  } catch (_) {}
}

export const onRouteUpdate = ({ location }) => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY)
    if (!raw) return
    const consent = JSON.parse(raw)
    if (consent.analytics === true && typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: location.pathname })
    }
  } catch (_) {}
}

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieBanner />
  </>
)

